import { Button, Col, Form, Spinner, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import { useEffect, useState } from "react";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { getCrmDDLService, getCrmLeadsService } from "../../../../Services/CRMAdminServices/CRMTaskListService";
import DropdownWithValueName from "../../../common/DropdownWithValueName";
import TextField from "../../../common/TextField";
import DatePicker from "../../../common/DatePicker";
import InfiniteScroll from "react-infinite-scroll-component";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";
import { updateLeadBulkStaffService } from "../../../../Services/CRMAdminServices/CRMTaskListService"; // Assuming this service is imported
import SelectDatePicker from "../../../common/SelectDatePicker";

const customStyles = {
    head: {
        style: {
            fontWeight: '800',
            color: '#0000ff',
            fontSize: '14px'
        },
    },
};

export default function BulkStaffChange() {
    const [leadDropdownData, setLeadDropdownData] = useState<any>([]);
    const [leads, setLeads] = useState<any>([]);
    const [hasMore, setHasMore] = useState(true);
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [selectedLeadsId, setSelectedLeadsId] = useState<any>([]);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const navigate = useSafeNavigate();
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [formData, setFormData] = useState<any>({
        source: "",
        staff: "",
        stage: "",
        textMessage: "",
        followUp: '', 
        assignToNewStaff: '', 
        newstageid: '', 
        commentText: '', 
        pageNumber: 0,
        pageSize: 100,
    });

    const { data: leadsDataDDL, isLoading: DDLloading } = useGetRequestQuery<any>(
        ['getCrmDDLService'],
        () => getCrmDDLService(),
        { enabled: true }
    );

    useEffect(() => {
        if (leadsDataDDL?.data && !DDLloading) {
            setLeadDropdownData(leadsDataDDL?.data || []);
        }
    }, [leadsDataDDL]);

    const handleValueChange = (name: string, value: string | Date | null) => {
        setFormData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const { data: leadsData, isLoading, isError, refetch } = useGetRequestQuery<any>(
        ['getCrmLeads', searchTrigger, formData.pageNumber, formData.pageSize, formData.stage, formData.staff, formData.source],
        () => getCrmLeadsService(formData) as any,
        { enabled: true }
    );

    // useEffect(() => {
    //     if (leadsData && !isError && !isLoading) {
    //         if (formData.pageNumber === 0) {
    //             setLeads(leadsData?.data || []);
    //         } else {
    //          //  setLeads((prevLeads: any) => [...prevLeads, ...(leadsData?.data || [])]);
    //                setLeads(leadsData?.data|| []);
    //              console.log("Fetched data count:", leadsData?.data?.length);


    //         }
    //         setHasMore(leadsData?.data.length === formData.pageSize);
    //         setIsLoadingMore(false);
    //     }
    // }, [leadsData]);



    
useEffect(() => {
    if (leadsData && !isError && !isLoading) {
        let results = leadsData?.data || [];

        // Workaround: Apply manual slicing for first page
        if (formData.pageNumber === 0 && results.length > formData.pageSize) {
            results = results.slice(0, formData.pageSize);
        }

        if (formData.pageNumber === 0) {
            setLeads(results);
        } else {
            //setLeads((prevLeads: any) => [...prevLeads, ...results]);
            setLeads(leadsData?.data || []);
        }

        if (!results || results.length < formData.pageSize) {
            setHasMore(false);
        } else {
            setHasMore(true);
        }
        setIsLoadingMore(false);
    }
}, [leadsData]);


    const fetchMoreData = () => {
        if (!isLoadingMore && hasMore) {
            setIsLoadingMore(true);
            setFormData((prev: any) => ({ ...prev, pageNumber: prev.pageNumber + 1 }));
            setSearchTrigger((prev) => prev + 1);
        }
    };

    const columns = [
        {
            name: "Followup",
            selector: (row: any) => {
                const date = new Date(row["followUp"]);
                if (isNaN(date.getTime())) {
                    return '';
                }
                return date.toLocaleDateString("en-GB");
            },
            sortable: false,
            width: '8rem'
        },
        {
            name: "First Name",
            selector: (row: any) => row.firstName
                ? row.firstName.charAt(0).toUpperCase() + row.firstName.slice(1).toLowerCase()
                : '',
            sortable: false,
            width: '8rem'
        },
        {
            name: "Surname",
            selector: (row: any) => row.surname.charAt(0).toUpperCase() + row.surname.slice(1),
            sortable: false,
            width: '8rem'
        },
        { name: "Email", selector: (row: any) => row.email, sortable: false, width: '12em' },
        { name: "Stage", selector: (row: any) => row.stage, sortable: false, width: '8rem' },
        { name: "Mobile", selector: (row: any) => row.mobile, sortable: false, width: '8rem' },
        { name: "Staff", selector: (row: any) => row.staff, sortable: false, width: '6rem' },
        // {
            
        //     name: "Comments", selector: (row: any) => row.latestComment, sortable: false, width: '25rem'

        //  },
         {
  name: "Comments",
  selector: (row: any) => row.latestComment,
  sortable: false,
//   width: '25rem',
  wrap: true, // allow text wrapping
  cell: (row: any) => <div style={{ whiteSpace: 'normal' }}>{row.latestComment}</div>
}

    ];

    const { mutate: updateBulkStaff, isPending: isUpdating } = useMutationRequestQuery(
        "updateLeadBulkStaff",
        updateLeadBulkStaffService,
        {
            onSuccess: () => {
                refetch();
                setFormData({ ...formData, followUp: '', commentText: '' }); // Resetting form data after successful API call
                toast.success("Staff updated successfully!", { position: "top-right" });
            },
            onError: () => {
                toast.error("Error updating staff.");
            }
        }
    );

const handleUpdateBulkStaff = () => {
    const leadsData = selectedLeadsId.map((leadId: any) => {
        const lead = leads.find((l: any) => l.leadID === leadId);
        return {
            leadId: lead.leadID,
            staffId: formData.assignToNewStaff,
            stageid: formData.newstageid,
            followUp: formData.followUp
        };
    });

    updateBulkStaff({ leads: leadsData });
};


   const handleSendBulkSms = async (event: React.FormEvent) => {
    event.preventDefault();

    if (selectedLeadsId.length === 0) {
        toast.warning("Please select at least one lead.");
        return;
    }

    // Validation for required fields
    if (!formData.assignToNewStaff) {
        toast.error("New Staff is required.");
        return;
    }
    if (!formData.newstageid) {
        toast.error("New Stage is required.");
        return;
    }
    if (!formData.followUp) {
        toast.error("FollowUp date is required.");
        return;
    }

    // // Confirmation before update
    // const confirmUpdate = window.confirm(
    //     "Do you want to update the Staff, Stage, and FollowUp for the selected leads?"
    // );

    // if (!confirmUpdate) {
    //     return; // If user cancels, do nothing
    // }
    setShowConfirmModal(true);

    // Proceed with bulk update
    // handleUpdateBulkStaff();
};


    return (
        <>
            <div className="px-4 py-4" style={{ minHeight: "300px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
                <Form style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "white", borderRadius: "8px", padding: "15px", paddingLeft: "30px" }}>
                    <div className="row">
                        <div className="d-flex justify-content-between align-items-center my-3">
                            <H3 className="heading-color f-w-900">Bulk Staff Change</H3>
                        </div>

                        <div className='d-flex'>
                            <Col className="responsive-col" xs={12} style={{ width: '40%' }}>
                                <DropdownWithValueName
                                    label="Stage :"
                                    name="stage"
                                    value={formData.stage}
                                    setValue={handleValueChange}
                                    options={leadDropdownData?.allStages || []}
                                    passCol="col-9"
                                    design="flex"
                                />
                            </Col>
                        </div>
                        <div className='d-flex'>
                            <Col className="responsive-col" xs={12} style={{ width: '40%' }}>
                                <DropdownWithValueName
                                    label="Source:"
                                    name="source"
                                    value={formData.source}
                                    setValue={handleValueChange}
                                    options={leadDropdownData?.leadSources || []}
                                    passCol="col-9"
                                    design="flex"
                                />
                            </Col>
                        </div>
                        <div className='d-flex'>
                            <Col className="responsive-col" xs={12} style={{ width: '40%' }}>
                                <DropdownWithValueName
                                    label="Staff:"
                                    name="staff"
                                    value={formData.staff}
                                    setValue={handleValueChange}
                                    options={leadDropdownData?.staff || []}
                                    passCol="col-9"
                                    design="flex"
                                />
                            </Col>
                        </div>
                        <div className='d-flex'>
                            <Col className="responsive-col" xs={12} style={{ width: '40%' }}>
                                <DropdownWithValueName
                                    label="New Staff:"
                                    name="assignToNewStaff"
                                    value={formData.assignToNewStaff}
                                    setValue={handleValueChange}
                                    options={leadDropdownData?.staff || []}
                                    passCol="col-9"
                                    design="flex"
                                />
                            </Col>
                        </div>
                               <div className='d-flex'>
                            <Col className="responsive-col" xs={12} style={{ width: '40%' }}>
                                <DropdownWithValueName
                                    label="New Stage :"
                                    name="newstageid"
                                    value={formData.newstageid}
                                    setValue={handleValueChange}
                                    options={leadDropdownData?.allStages || []}
                                    passCol="col-9"
                                    design="flex"
                                />
                            </Col>
                        </div>
                        <div className='d-flex'>
                            <Col className="responsive-col" xs={12} style={{ width: '40%' }}>
                                {/* <DatePicker
                                    label="FollowUp"
                                    name="followUp"
                                    value={formData.followUp}
                                    setValue={handleValueChange}
                                    passCol="col-9"
                                    design="flex"
                                /> */}

                                      <SelectDatePicker
                                                label="FollowUp"
                                                name="followUp"
                                                value={formData.followUp}
                                                setValue={handleValueChange}
                                                passCol="col-9"
                                                design="flex"
                                                tabIndex={8}
                                                autoComplete="new-password"
                                            />
                            </Col>
                        </div>
                    </div>

                    <div className="d-flex gap-3 py-3">
                        <Button
                            onClick={() => navigate('/CRMTaskList')}
                            color="secondary"
                        >
                            Back
                        </Button>
                        <Button
                            onClick={handleSendBulkSms}
                            color="primary"
                            type="submit"
                        >
                            Submit
                        </Button>
                    </div>

            {/*   {isLoading ? (
                        <div style={{
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            padding: '12px',
                            backgroundColor: '#fff',
                            textAlign: 'center'
                        }} className='mt-4 mb-2'>
                            <Spinner color="primary"></Spinner>
                        </div>
                    ) : leads.length !== 0 ? (
                        <InfiniteScroll
                            dataLength={leads.length}
                            next={fetchMoreData}
                            hasMore={hasMore}
                            loader={
                                <div style={{
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    padding: '12px',
                                    backgroundColor: '#fff',
                                    textAlign: 'center'
                                }} className='mt-4 mb-2'>
                                    <Spinner color="primary"></Spinner>
                                </div>
                            }
                            scrollThreshold="90%"
                        >
                            <DataTable
                                columns={columns}
                                data={leads}
                                responsive
                                customStyles={customStyles}
                                selectableRows
                                onSelectedRowsChange={({ selectedRows }) => {
                                    const selectedIds = selectedRows.map((row) => row.leadID);
                                    setSelectedLeadsId(selectedIds);
                                }}
                                clearSelectedRows={toggleCleared}
                            />
                        </InfiniteScroll>
                    ) : (
                        <div style={{
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            padding: '12px',
                            backgroundColor: '#fff',
                            textAlign: 'center'
                        }} className='mt-4 mb-2'>
                            <h6>No Leads data available.</h6>
                        </div>
                    )}
*/}


{isLoading ? (
    <div style={{
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        padding: '12px',
        backgroundColor: '#fff',
        textAlign: 'center'
    }} className='mt-4 mb-2'>
        <Spinner color="primary"></Spinner>
    </div>
) : leads.length !== 0 ? (
    <>
        <DataTable
            columns={columns}
            data={leads}
            responsive
            customStyles={customStyles}
            selectableRows
            onSelectedRowsChange={({ selectedRows }) => {
                const selectedIds = selectedRows.map((row) => row.leadID);
                setSelectedLeadsId(selectedIds);
            }}
            clearSelectedRows={toggleCleared}
        />

        {/* Pagination Controls */}
        <div className="d-flex justify-content-between align-items-center mt-3">
            <Button
                color="secondary"
                disabled={formData.pageNumber === 0}
                onClick={() => {
                    setFormData((prev: any) => ({
                        ...prev,
                        pageNumber: prev.pageNumber - 1
                    }));
                    setSearchTrigger((prev) => prev + 1);
                }}
            >
                Prev
            </Button>
            <span>
                Page {formData.pageNumber + 1}
            </span>
            <Button
                color="secondary"
                disabled={leads.length < formData.pageSize}
                onClick={() => {
                    setFormData((prev: any) => ({
                        ...prev,
                        pageNumber: prev.pageNumber + 1
                    }));
                    setSearchTrigger((prev) => prev + 1);
                }}
            >
                Next
            </Button>
        </div>
    </>
) : (
    <div style={{
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        padding: '12px',
        backgroundColor: '#fff',
        textAlign: 'center'
    }} className='mt-4 mb-2'>
        <h6>No Leads data available.</h6>
    </div>
)}


                                
                </Form>
            </div>


            <Modal isOpen={showConfirmModal} toggle={() => setShowConfirmModal(false)} centered>
  <ModalHeader toggle={() => setShowConfirmModal(false)}>
    Confirm Update
  </ModalHeader>
  <ModalBody>
    <p>
      Do you want to update the <b>Staff</b>, <b>Stage</b>, and <b>FollowUp</b> 
      for the selected leads?
    </p>
  </ModalBody>
  <ModalFooter>
    <Button color="secondary" onClick={() => setShowConfirmModal(false)}>
      Cancel
    </Button>
    <Button
      color="primary"
      onClick={() => {
        setShowConfirmModal(false);
        handleUpdateBulkStaff(); // Proceed with update
      }}
    >
      Yes, Update
    </Button>
  </ModalFooter>
</Modal>
        </>
    );
}
